import { render, staticRenderFns } from "./AppointmentCalendarEditList.vue?vue&type=template&id=12d2d637"
import script from "./AppointmentCalendarEditList.vue?vue&type=script&lang=js"
export * from "./AppointmentCalendarEditList.vue?vue&type=script&lang=js"
import style0 from "./AppointmentCalendarEditList.vue?vue&type=style&index=0&id=12d2d637&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./AppointmentCalendarEditList.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports